import { environment } from "src/environments/environment";
import { Sso } from "../consts";

export const getMsalConfig=(tenantId?: string, clientId?: string) => ({
  auth: {
    clientId   : clientId || environment.sureSimClientId_Microsoft,
    authority  : tenantId ? `${Sso.Microsoft_LoginRoot}${tenantId}` : `${Sso.Microsoft_LoginRoot}${Sso.Microsoft_TenantId_Common}`,
    redirectUri: environment.sureSimRootUrl + Sso.Microsoft_RedirectRoute
  },
  cache: {
    cacheLocation         : "localStorage",
    storeAuthStateInCookie: true
  }
});
